import { useDispatch, useSelector } from 'react-redux';

import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';
import {
    analyticsCKPartnerHostedOnboardingRejectionScreen,
    analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard,
} from '@perpay-web/fintech/actions/analytics/partnerHostedOnboarding';
import CardStandardRejection from '@perpay-web/fintech/components/composite/PartnerOnboardingRejectedCreditKarma/CardStandardRejection';
import CardRejectedPassedKycContainer from '@perpay-web/fintech/components/containers/CardRejectedPassedKycContainer';
import {
    getPassedIdv,
    fetchCardAccountApplicationDataModule,
} from '@perpay-web/fintech/dataModules/fetchCardAccountApplications';

const CardRejectedContainer = () => {
    const dispatch = useDispatch();
    const passedKyc = useSelector(getPassedIdv);
    const isLoadingOrUnrequested = useSelector(
        fetchCardAccountApplicationDataModule.getIsLoadingOrUnrequested,
    );

    if (isLoadingOrUnrequested) {
        return <WarningLoaderCircle />;
    }

    if (!passedKyc) {
        return (
            <CardStandardRejection
                onMount={() => {
                    dispatch(
                        analyticsCKPartnerHostedOnboardingRejectionScreen(),
                    );
                }}
                onClickDashboard={() =>
                    dispatch(
                        analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard(),
                    )
                }
                isPho={false}
            />
        );
    }

    return <CardRejectedPassedKycContainer isPho={false} />;
};

export default CardRejectedContainer;
